import { recommendedActionsSubscriptions } from 'redux/recommendedActions/recommendedActionsSubscriptions';

export const subscriptions = [...recommendedActionsSubscriptions];
